import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { useLocation } from "react-router-dom";
import { PageActionPermission } from "services/pageActionPermission/PageActionPermission";
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('component_delete_modal');

interface DeleteModalProps {
  show ?: boolean;
  onDeleteClick ?: () => void;
  onCloseClick ?: () => void;
  recordId ?: number;
  recordName?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ show, onDeleteClick, onCloseClick, recordId, recordName }) => {
  const location = useLocation();
  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <i className="ri-delete-bin-line display-5 text-danger"></i>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>{st('xac_nhan_xoa_title')}</h4>
            <p className="text-muted mx-4 mb-0">
              {st('ban_co_chac_chan_muon_xoa_text')} {recordName ? `“${recordName}”` : recordId ? st('ban_ghi_record_id_text', { record_id: recordId }) : st('muc_da_chon_text')} {st('khong_text')}
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            {st('dong_button')}
          </button>
          {PageActionPermission.canDisplay(location.pathname, "button-delete-confirm") && (
            <button
              type="button"
              className="btn w-sm btn-danger "
              id="delete-record"
              data-action-code="button-delete-confirm"
              data-action-name="Xác nhận xóa bản ghi"
              onClick={onDeleteClick}
            >
              {st('xoa_button')}
            </button>
          )}
        </div>
      </ModalBody>
    </Modal>
  ) as unknown as JSX.Element;
};

export default DeleteModal;
